export const plans = [
  {
    id: "basic",
    name: "Basic",
    price: 149,
    priceLabel: "$149",
    currency: "USD",
    tagline: "Get a professional online presence — fast.",
    audience: "For small businesses that need a clean, credible website.",
    delivery: "5–7 days",
    featured: false,
    features: [
      "Single page website",
      "Mobile responsive design",
      "Contact / WhatsApp button",
      "Basic SEO setup",
      "Hosting setup guidance",
    ],
  },
  {
    id: "standard",
    name: "Standard",
    price: 489,
    priceLabel: "$489",
    currency: "USD",
    tagline: "A real business site with customer interaction.",
    audience: "For businesses that need menus, services, or booking forms.",
    delivery: "7–14 days",
    featured: true,
    features: [
      "Multi-section website",
      "Menu, services or booking form",
      "WhatsApp automation",
      "Basic dashboard or form management",
      "1 revision round",
      "Domain + email setup support",
    ],
  },
  {
    id: "premium",
    name: "Premium",
    price: 989,
    priceLabel: "from $989",
    currency: "USD",
    tagline: "A full smart system, end to end.",
    audience: "For businesses that want a real digital edge.",
    delivery: "2–4 weeks",
    featured: false,
    features: [
      "Full custom website",
      "Booking or ordering system",
      "AI chatbot or support agent",
      "Admin dashboard demo",
      "Automation workflows",
      "Priority support",
    ],
  },
];
